import React, { useEffect, useLayoutEffect, useRef } from 'react';
import LoadingSpinner from '../../components/LoadingSpinner';
import ChatMessage from './ChatMessage';

const SupportChatMessageList = ({ messages, loading }) => {
  const listRef = useRef(null);
  const contentRef = useRef(null);

  const scrollToBottom = () => {
    const list = listRef.current;
    if (!list) return;
    list.scrollTop = list.scrollHeight;
  };

  // After DOM updates (new messages, pending → confirmed) keep the latest message in view.
  useLayoutEffect(() => {
    scrollToBottom();
  }, [messages]);

  // Images / attachments can grow the list after paint — follow them too.
  useEffect(() => {
    const content = contentRef.current;
    if (!content) return undefined;

    const observer = new ResizeObserver(() => {
      scrollToBottom();
    });
    observer.observe(content);

    return () => observer.disconnect();
  }, [loading, messages.length]);

  if (loading && messages.length === 0) {
    return (
      <div className="flex-1 flex justify-center py-8 min-h-0">
        <LoadingSpinner error={[]} loading={true} />
      </div>
    );
  }

  return (
    <div ref={listRef} className="flex-1 min-h-0 overflow-y-auto p-4">
      <div ref={contentRef} className="space-y-3">
        {messages.map((message) => (
          <ChatMessage key={message.id} message={message} />
        ))}
      </div>
    </div>
  );
};

export default SupportChatMessageList;
